export default "__VITE_ASSET__DMdDHMGH__"